<prlw-all-table-column-content-ui
  [data]="instrument"
  [column]="column"
  [modifiers]="modifiers"
  [destination]="destination"
></prlw-all-table-column-content-ui>
